export enum CollapseKeys {
  collapse = 'collapse',
}

export type TCollapseKeys = `${CollapseKeys}`;
